<template>
  <div>
    <Asset :asset="projectAsset.asset" />
  </div>
</template>

<script>
import Asset from './Asset.vue';

export default {
  components: {
    Asset,
  },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
};
</script>
